<section id="footer">
    <div class="container">
        <div class="row wow fadeInUp">
            <div class="col-lg-12  text-center"><br> © Copyright 2021 MithraTechnoSoft</div>
        </div>
    </div>

</section>